import { ToggleFilter } from './typings'

export const toggleFilterActionCreator = (payload: string): ToggleFilter => ({
  type: 'activityHistoryFilters/toggle',
  payload,
})
